import React, { useEffect, useState } from 'react';
import { Box, Grid, Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/core/styles';

import AssessmentPage from 'on_web/components/shared/AssessmentPage/AssessmentPage';
import ErrorMessageTile from 'on_web/components/shared/ErrorMessageTile/ErrorMessageTile';
import CustomDialog from 'on_web/components/shared/CustomDialog/CustomDialog';

import useUsersApi from 'on_web/hooks/useUsersApi';
import useCheckScreenSize from 'on_web/hooks/useCheckScreenSize';

import { mapRoutesToMenuItems } from 'on_web/helpers/menuItems';
import { Divider } from '@material-ui/core';
import { parseHealthRisks, parseLikelihood } from 'on_web/helpers/risksHelper';
import { notApplicable } from 'on_web/assets/imageList';

import { APP_PRIMARY } from 'colours';

export default function ReportsLikelihood(props) {
  const { t } = useTranslation();

  const [isDesktop] = useCheckScreenSize();

  const [{ getSpareAssessments, errorSpareAssessments }] = useUsersApi();
  const [responseHealthBasedRisks, setResponseHealthBasedRisks] = useState(
    null
  );
  const [healthBasedRisksObj, setHealthBasedRisksObj] = useState(null);
  const [likelihoodObj, setLikelihoodObj] = useState(null);
  const [responseLikelihood, setResponseLikelihood] = useState(null);

  const useStyles = makeStyles(() => ({
    title: {
      fontFamily: 'MuseoSans-500',
      fontSize: 22,
      lineHeight: '28px',
      textAlign: isDesktop ? 'left' : 'center',
      padding: isDesktop ? 0 : 2,
    },
    riskLevel: {
      fontFamily: 'MuseoSans-900',
      fontSize: 22,
      lineHeight: '28px',
      textAlign: isDesktop ? 'left' : 'center',
      textTransform: 'uppercase',
    },
    percentage: {
      fontSize: isDesktop ? '65px' : '55px',
      fontFamily: 'Museo-900',
    },
    text: {
      fontSize: '14px',
    },
  }));
  const classes = useStyles();

  useEffect(() => {
    if (
      props.location.state &&
      props.location.state.healthBasedRisks &&
      props.location.state.infectionLikelihood
    ) {
      setResponseHealthBasedRisks(props.location.state.healthBasedRisks);
      setHealthBasedRisksObj(
        parseHealthRisks(props.location.state.healthBasedRisks)
      );
      setResponseLikelihood(props.location.state.infectionLikelihood);
      setLikelihoodObj(
        parseLikelihood(props.location.state.infectionLikelihood, t)
      );
    } else {
      getSpareAssessments().then(resp => {
        if (resp) {
          setResponseHealthBasedRisks(resp.health_based_severity);
          setHealthBasedRisksObj(parseHealthRisks(resp.health_based_severity));
          setResponseLikelihood(resp.past_infection_likelihood);
          setLikelihoodObj(parseLikelihood(resp.past_infection_likelihood, t));
        }
      });
    }
  }, [getSpareAssessments]);

  const getInfectionDetails = infection => {
    if (isDesktop) {
      return (
        <Grid container justify="center">
          <Grid item xs={12}>
            <Divider />
          </Grid>
          <Grid item xs={12}>
            <Box
              display={'block'}
              textAlign={'center'}
              style={{ marginTop: 30, marginLeft: 10, marginRight: 10 }}
            >
              {infection.level > -1 ? (
                <Typography variant="h2" style={{ color: APP_PRIMARY }}>
                  {infection.percentage}
                </Typography>
              ) : (
                <img src={notApplicable} alt="not applicable illustration" />
              )}
            </Box>
          </Grid>
          <Grid item xs={12}>
            <Box
              display={'block'}
              textAlign={'center'}
              style={{
                marginTop: 13,
                minHeight: 50,
                marginLeft: 10,
                marginRight: 10,
              }}
            >
              <Typography variant="h2">{infection.name}</Typography>
            </Box>
          </Grid>
          <Grid item xs={12}>
            <Box
              display={'block'}
              textAlign={'center'}
              style={{ marginTop: 13, marginLeft: 10, marginRight: 10 }}
            >
              <Typography variant="body1">{infection.accuracy}</Typography>
            </Box>
          </Grid>
        </Grid>
      );
    } else {
      return (
        <Grid container justify="center">
          <Grid item xs={12}>
            <Divider />
          </Grid>
          <Grid item xs={12} style={{ marginTop: 15, marginBottom: 15 }}>
            <Grid container>
              <Grid item xs={10} style={{ paddingRight: 15 }}>
                <Typography variant="h2">{infection.name}</Typography>
              </Grid>
              <Grid item xs={2}>
                {infection.level > -1 ? (
                  <Typography variant="h2" style={{ color: APP_PRIMARY }}>
                    {infection.percentage}
                  </Typography>
                ) : (
                  <img src={notApplicable} alt="not applicable illustration" />
                )}
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} style={{ marginBottom: 15 }}>
            <Typography variant="body1" className={classes.text}>
              {infection.accuracy}
            </Typography>
          </Grid>
        </Grid>
      );
    }
  };

  const getStateToTransfer = () => {
    return {
      healthBasedRisks: responseHealthBasedRisks,
      infectionLikelihood: responseLikelihood,
    };
  };

  return errorSpareAssessments ? (
    <CustomDialog
      open={errorSpareAssessments}
      onCloseButton={() => {
        window.location = '/';
      }}
      style={{ marginLeft: isDesktop ? '300px' : '0' }}
    >
      <ErrorMessageTile
        level="error"
        title={t('common.errorMessages.general.title')}
        message={t('common.errorMessages.general.message')}
        actionText={t('common.errorMessages.general.reloadAction')}
        onButtonClick={() => {
          window.location = '/';
        }}
      ></ErrorMessageTile>
    </CustomDialog>
  ) : (
    <AssessmentPage
      headerMenuText={t('reporting.myAssessment.likelihoodHistoryTitle')}
      bottomMenuSelectedOptionCode={'likelihood-history'}
      desktopMenuIndex={3}
      secondaryHeaderWithBackNavigation={false}
      stateToTransfer={getStateToTransfer()}
      hasShareAction={true}
      secondaryHeader={true}
    >
      <Box px={'20px'} py={'10px'} mb={'60px'}>
        <Grid container justify="center" direction="column">
          {isDesktop && (
            <Grid
              item
              xs={12}
              style={{ paddingTop: '60px', paddingBottom: '40px' }}
            >
              <Typography variant={'h2'}>
                {t('reporting.myAssessment.likelihoodHistoryTitle')}
              </Typography>
            </Grid>
          )}
          {likelihoodObj && (
            <>
              <Grid item xs={12}>
                <Box className={classes.title}>
                  <Typography
                    variant={'h2'}
                    style={{ fontWeight: 'normal', color: likelihoodObj.color }}
                  >
                    {t('reporting.myAssessment.probabilityYouHaveHad')}{' '}
                    <b>{likelihoodObj.levelText.toUpperCase()}</b>
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={12}>
                <Grid container justify="center">
                  <Grid item xs={isDesktop ? 6 : 12}>
                    <Grid container justify="center">
                      <Grid item xs={12}>
                        <Box display={'block'} textAlign={'center'}>
                          {likelihoodObj.illustration}
                        </Box>
                      </Grid>
                      <Grid item xs={12}>
                        <Box display={'block'} textAlign={'center'}>
                          {likelihoodObj.bar}
                        </Box>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item xs={isDesktop ? 6 : 12}>
                    {/*likelihoodObj.scoreDescription.map((desc, ix) => {
                      return (
                        <Box key={ix} style={{ paddingTop: '28px' }}>
                          <Typography variant={'body1'}>{desc}</Typography>
                        </Box>
                      );
                    })*/}

                    <Box style={{ paddingTop: '28px' }}>
                      <Typography variant="body1" className={classes.text}>
                        {likelihoodObj.disclaimer}
                      </Typography>
                    </Box>

                    <Box style={{ paddingTop: '28px', paddingBottom: '40px' }}>
                      <Typography variant="body1" className={classes.text}>
                        {likelihoodObj.disclaimer2}
                      </Typography>
                    </Box>
                  </Grid>

                  <Grid item xs={isDesktop ? 4 : 12}>
                    {getInfectionDetails(likelihoodObj.testbasedInfection)}
                  </Grid>
                  <Grid item xs={isDesktop ? 4 : 12}>
                    {getInfectionDetails(
                      likelihoodObj.antiBodyTestBasedInfection
                    )}
                  </Grid>
                  <Grid item xs={isDesktop ? 4 : 12}>
                    {getInfectionDetails(likelihoodObj.symptomBasedInfection)}
                  </Grid>
                </Grid>
              </Grid>
            </>
          )}
        </Grid>
      </Box>
    </AssessmentPage>
  );
}
